import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/lib/customer-validators';
import { ProgrammeService } from 'src/app/services/programme.service';
import { Programme } from 'src/app/models/programme';

@Component({
  selector: 'app-new-programme',
  templateUrl: './new-programme.component.html',
  styleUrls: ['./new-programme.component.scss']
})
export class NewProgrammeComponent implements OnInit {
  public programmeForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<NewProgrammeComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private programmeService: ProgrammeService
  ) {
      this.programmeForm = new FormGroup({
        'name': new FormControl(null, [Validators.required, CustomValidators.validateTextField])
      });
    }

  ngOnInit() {
  }

  cancel(){
    this.dialogRef.close(false);
  }

  submit(){
    let programme = new Programme();
    programme.name = this.programmeForm.get('name').value;
    programme.type = this.data.type;

    this.programmeService.createProgramme(programme).subscribe(res=>{
      this.dialogRef.close(true);
    })
  }
}
